const Report = () =>
  import(/* webpackChunkName: "order-draft" */ '@/pages/order/draft/index.vue')
const Detail = () =>
  import(/* webpackChunkName: "order-draft" */ '@/pages/order/draft/detail.vue')

export default {
  path: 'draft',
  meta: {
    label: 'ShipmentDraft',
    auth: 'draft'
  },
  component: {
    name: 'Draft',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'OrderDraftReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'OrderDraftDetail',
      path: ':id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    }
  ]
}
